<div class="subpage-card">
  <div class="subpage-header">
    <div class="header-title">
      <h2 class="subpage-title">{{ title }}</h2>
      @if (updatedAt) {
        <span class="meta">
          <app-time-ago [updatedAt]="updatedAt" format="short"></app-time-ago>
        </span>
      }
    </div>
    @if (showInfoButton) {
      <app-v3-info-button
        [size]="20"
        [opensPage]="true"
        (pageClicked)="infoClicked.emit()"
      ></app-v3-info-button>
    }
  </div>
  <div class="subpage-content">
    <ng-content></ng-content>
  </div>
</div>
